import {
  REPORT_LOADING,
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAIL,
  REPORT_RESET
} from "./actionType";

const INIT_STATE = {
  reports: [],
  error: {},
};

const Report = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REPORT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_REPORT:
          return {
            ...state,
            reports: action.payload.data,
            isReportCreated: false,
            isReportSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_REPORT_FAIL:
      switch (action.payload.actionType) {
        case GET_REPORT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isReportCreated: false,
            isReportSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_REPORT: {
      return {
        ...state,
        isReportCreated: false,
        loading: true,
      };
    }

    case REPORT_LOADING: {
      return {
        ...state,
        isReportCreated: false,
        loading: true,
      };
    }
    
    case REPORT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Report;